/* tslint:disable */
//  This file was automatically generated and should not be edited.
export enum ProductStatus {
  /**
   * Aktuálny
   */
  STATUS_ACTIVE = "STATUS_ACTIVE",
  /**
   * Blokovaný
   */
  STATUS_BLOCKED = "STATUS_BLOCKED",
  /**
   * Zmazaný
   */
  STATUS_DELETED = "STATUS_DELETED",
  /**
   * Expirovaný
   */
  STATUS_EXPIRED = "STATUS_EXPIRED",
  /**
   * Pozastavený
   */
  STATUS_INACTIVE = "STATUS_INACTIVE",
}